/**
 * Módulo `ready-room` — escena de la ready room del CVN-51 (Fase 5g.3).
 *
 * Inicializa `/portaaviones.html`: reloj digital de pared, gestión
 * día/noche (con el modo ciclo del CRT), el "Bolter del día" proyectado
 * y el editor visual de hotspots (tecla E). Reúsa el editor del módulo
 * `scene`; descarta lo acoplado a la sala de operaciones (auth-guard,
 * transición CRT-off, ciclador día/tarde/noche). La escena es pública —
 * se llega desde el hotspot "EMBARCAR" de la home.
 */

import { me } from '../auth/api.js';
import { initEditor } from '../scene/editor.js';
import { startBolterOfDay } from './bolter-of-the-day.js';
import { startReadyRoomClock } from './clock.js';
import { startReadyRoomTimeOfDay } from './time-of-day.js';

import './ready-room.css';

/** Inicializa la ready room cuando el DOM está listo. */
export function initReadyRoom(): void {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
}

function boot(): void {
  startReadyRoomClock();
  startReadyRoomTimeOfDay();
  startBolterOfDay();
  void initEditorIfAllowed();
}

/**
 * Monta el editor de hotspots según el contexto:
 *  - En dev: siempre (es la herramienta para afinar coordenadas).
 *  - En producción: solo para el superadmin.
 *
 * Mismo criterio que la sala de operaciones (`scene/index.ts`).
 */
async function initEditorIfAllowed(): Promise<void> {
  if (import.meta.env.DEV) {
    initEditor();
    return;
  }
  const result = await me();
  if (result.ok && result.data.user.role === 'superadmin') {
    initEditor({ showHint: false });
  }
}
